import React from "react";
import { Flex, Text, Button, Icon } from "@chakra-ui/react";
import { FaCircleInfo } from "react-icons/fa6";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { primaryAlt, textSecondary, color3 } from "../../../../../utils/colors";
import useThemeColors from "../../../../../hooks/useThemeColors";

const SaveButtons = ({ onClose, onClick }) => {
  const { t } = useTranslation();

  // COLORS
  const { whiteMode, backgroundLightMode } = useThemeColors();

  return (
    <Flex
      as={motion.div}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.3 }}
      w="100%"
      justify="space-between"
      p={["2rem 0rem", "2rem 0rem"]}
    >
      <Flex align="center" ml="40%">
        <Icon as={FaCircleInfo} fontSize="0.875rem" color={primaryAlt} mr={1} />
        <Text fontSize="sm" color={textSecondary} fontWeight="500">
          {t("clinicSettings.saveChanges")}
        </Text>
      </Flex>
      <Flex align="center" justify="flex-end">
        <Button
          size="lg"
          fontSize="sm"
          bg={backgroundLightMode}
          color={textSecondary}
          borderRadius="10rem"
          mr="1rem"
          onClick={onClose}
        >
          {t("button.cancel")}
        </Button>
        <Button
          size="lg"
          fontSize="sm"
          bg={primaryAlt}
          color={whiteMode}
          borderRadius="10rem"
          mr="1rem"
          onClick={onClick}
          _hover={{
            bg: color3,
            color: whiteMode,
          }}
        >
          {t("button.save")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default SaveButtons;
